import { DEFAULT_DATE_RANGE_DAYS } from 'src/apps/dashboard/constants/DashboardFiltersDefinitions';
import { DistinctEnvironmentsQuery } from 'src/apps/dashboard/services/queries/distinct-environments/DistinctEnvironments.generated';
import { DistinctEnvironments } from 'src/apps/dashboard/services/queries/distinct-environments/DistinctEnvironments.gql';
import { gqlClient } from 'src/common/services/api/GraphQLRequestApi';
import { Logger } from 'src/common/services/Logger';

export const getDistinctEnvironments = async (): Promise<string[]> => {
	try {
		const result = await gqlClient.request<DistinctEnvironmentsQuery>(DistinctEnvironments, {
			days: DEFAULT_DATE_RANGE_DAYS
		});
		const values = (result.score_web_products ?? [])
			.map((item) => item?.environment)
			.filter((env): env is string => Boolean(env));
		return [...new Set(values)];
	} catch (error) {
		Logger.error('DistinctEnvironmentsService -> getDistinctEnvironments failed:', error);
		return [];
	}
};
